import {AdapterProps, FieldAdapter} from '../field-factory';
import {Switch as MantineSwitch, SwitchProps} from '@mantine/core';
import {FC, useContext} from 'react';
import {ReadOnlyContext} from '../readonly-context';

export type $SwitchAdapterProps = AdapterProps<SwitchProps>;

export const $SwitchAdapter: FC<FieldAdapter<$SwitchAdapterProps>> = ({
  inputProps: {disabled, onChange, ...inputProps},
  control,
}) => {
  const {readOnly} = useContext(ReadOnlyContext);
  const {
    field: {value, onChange: fieldOnChange, ...fieldProps},
    fieldState: {invalid},
  } = control;

  const _onChange: SwitchProps['onChange'] = (newValue) => {
    fieldOnChange(newValue);
    onChange?.(newValue);
  };

  return (
    <MantineSwitch
      error={invalid}
      disabled={disabled || readOnly}
      onChange={_onChange}
      checked={value}
      {...fieldProps}
      {...inputProps}
    />
  );
};